import React from 'react';

interface HeroVideoBackgroundProps {
  children?: React.ReactNode;
}

const HeroVideoBackground: React.FC<HeroVideoBackgroundProps> = ({ children }) => {
  return (
    <div className="hero-video-container position-relative">
      <video
        id="hero-background-video"
        autoPlay
        loop
        muted
        playsInline
        poster="/assets/images/poster.jpg"
        className="hero-video"
      >
        <source src="/assets/videos/wrap_bg_small.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="hero-video-overlay">
        {children}
      </div>
    </div>
  );
};

export default HeroVideoBackground;
